import {
  getCurrentCropYear,
  getCropYears,
  getCommoditiesForCropYear,
  getCustomerFarmFields,
  getDigiFarmFields,
  getHiResDigiFarmFields,
  emailCustomerFarmFieldMapping,
  emailCustomerFarmFieldMappingWithUserDrawing,
  getCustomerFarmFieldsList,
  getNetOfFreightLocations,
  getCustomerFarmFieldsWithNutrientRemoval,
} from '../../../apis/premier-plus-api';
import {handleApiError} from '../../../shared/actions';

export const initMyFieldsInterface = () => (async (dispatch, getState) => {
  dispatch({
    type: 'INIT_MY_FIELDS_INTERFACE',
  });
  await dispatch(fetchCurrentCropYear());
  await dispatch(fetchCropYears());
  await dispatch(fetchCommodities());
  dispatch(fetchFarmFields(true));
});

export const fetchCurrentCropYear = () => (async (dispatch, getState) => {
  var response = null;
  try {
    response = await getCurrentCropYear();
  } 
  catch (error) {
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_CURRENT_CROP_YEAR',
    currentCropYear: response.body,
  });
});

export const fetchCropYears = () => (async (dispatch, getState) => {
  var response = null;
  try {
    response = await getCropYears();
  } 
  catch (error) {
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_CROP_YEARS',
    cropYears: response.body,
  });
});

export const fetchCommodities = () => (async (dispatch, getState) => {
  const growerId = getState().auth.authorization.growerId;
  const selectedCropYear = getState().mapping.selectedCropYear;
  var response = null;
  try {
    response = await getCommoditiesForCropYear(growerId, selectedCropYear);
  } 
  catch (error) {
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_COMMODITIES',
    commodities: response.body,
  });
});

export const fetchFarmFields = (getMappedFields) => (async (dispatch, getState) => {
  dispatch({
    type: 'FETCH_FARM_FIELDS_STARTED',
  });
  const growerId = getState().auth.authorization.growerId;
  const selectedCropYear = getState().mapping.selectedCropYear;
  var selectedCommodity = getState().mapping.selectedCommodity;
  const commoditiesDropDownListDataSource = getState().mapping.commoditiesDropDownListDataSource;
  const hasCommodity = commoditiesDropDownListDataSource.some(item => item.label === selectedCommodity);
  if (hasCommodity === false && commoditiesDropDownListDataSource.length > 0) {
    selectedCommodity = commoditiesDropDownListDataSource[0].label;
  }
  var response = null;
  try {
    response = await getCustomerFarmFields(growerId, getMappedFields, selectedCropYear, selectedCommodity);
  } 
  catch (error) {
    dispatch({
      type: 'FETCHING_FARM_FIELDS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  if (getMappedFields === true) {
    dispatch({
      type: 'FETCHED_MAPPED_FARM_FIELDS',
      mappedFarmFields: response.body,
    });
  }
  else {
    dispatch({
      type: 'FETCHED_NON_MAPPED_FARM_FIELDS',
      nonMappedFarmFields: response.body,
    });
  }
});

export const userSelectedCropYear = (selectedCropYear) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_CROP_YEAR',
    selectedCropYear: selectedCropYear,
  });
  await dispatch(fetchCommodities());
  dispatch(fetchFarmFields(true));
});

export const userSelectedCommodity = (selectedCommodity) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_COMMODITY',
    selectedCommodity: selectedCommodity,
  });
  dispatch(fetchFarmFields(true));
});

export const userSelectedMappedFarmField = (selectedMappedFarmField) => (async (dispatch, getState) => {
  await dispatch({
    type: 'CLEAR_MAPPED_FARM_FIELD_POLYGONS',
  });
  dispatch({
    type: 'USER_SELECTED_MAPPED_FARM_FIELD',
    selectedMappedFarmField: selectedMappedFarmField,
  });
});

export const fetchDigiFarmFields = (minLongitude, minLatitude, maxLongitude, maxLatitude, isMappedFieldsInterface) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_REQUESTED_FETCH_DIGIFARM_FARM_FIELDS',
  });
  var response = null;
  try {
    response = await getDigiFarmFields(minLongitude, minLatitude, maxLongitude, maxLatitude);
  } 
  catch (error) {
    dispatch({
      type: 'FETCH_DIGIFARM_FARM_FIELDS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  if (isMappedFieldsInterface === true) {
    dispatch({
      type: 'FETCHED_DIGIFARM_FARM_FIELDS_FOR_MAPPED_FIELDS_INTERFACE',
      digiFarmFields: response.body,
    });
  }
  else {
    dispatch({
      type: 'FETCHED_DIGIFARM_FARM_FIELDS_FOR_NON_MAPPED_INTERFACE',
      digiFarmFields: response.body,
    });
  }
});

export const initMapMyFieldsInterface = (customerFarm) => (async (dispatch, getState) => {
  dispatch({
    type: 'INIT_MAP_MY_FIELDS_INTERFACE',
  });
  dispatch(fetchFarmFields(false));
});

export const userTappedDrawFieldBooundaries = () => (async (dispatch, getState) => {
  await dispatch({
    type: 'USER_TAPPED_DRAW_FIELD_BOUNDARIES',
  });
});

export const userSelectedNonMappedFarmField = (selectedNonMappedFarmField) => (async (dispatch, getState) => {
  await dispatch({
    type: 'USER_SELECTED_NON_MAPPED_FARM_FIELD',
    selectedNonMappedFarmField: selectedNonMappedFarmField,
  });
});

export const handleNonMappedFarmFieldsBoundsChange = (bounds) => (async (dispatch, getState) => {
  if (getState().mapping.showDrawFieldBoundaryControls === true) {
    return;
  }
  const ne = bounds.map.getBounds().getNorthEast();
  const sw = bounds.map.getBounds().getSouthWest();
  if (bounds.detail.zoom >= 14) {
    dispatch(fetchDigiFarmFields(sw.lng(), sw.lat(), ne.lng(), ne.lat(), false));
  }
  else if (bounds.detail.zoom < 14) {
   bounds.map.data.forEach((feature) => {
    bounds.map.data.remove(feature);
   });
  }
});

export const submitNonMappedFarmFields = (selectedFarmFields) => (async (dispatch, getState) => {
  dispatch({
    type: 'SUBMIT_NON_MAPPED_FARM_FIELDS_STARTED',
  });
  var ids = [];
  selectedFarmFields.forEach((field) => {
    ids.push(field.getId())
  });
  var response = null;
  try {
    response = await getHiResDigiFarmFields(ids);
  } 
  catch (error) {
    dispatch({
      type: 'SUBMIT_NON_MAPPED_FARM_FIELDS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_HI_RES_NON_MAPPED_DIGIFARM_FARM_FIELDS',
    nonMappedHiResDigiFarmFields: response.body,
  });
});

export const completeNonMappedFarmFieldsSubmission = (mapCenterLatitude, mapCenterLongitude, base64ScreenCapture, digiFields) => (async (dispatch, getState) => {
  const selectedNonMappedFarmField = getState().mapping.selectedNonMappedFarmField;
  const agvanceUser = getState().auth.authorization.agvanceUser;
  const ipifyResponse = await fetch('https://api64.ipify.org?format=json');
  const ipifyResponseJson = await ipifyResponse.json();
  try {
      await emailCustomerFarmFieldMapping(agvanceUser, ipifyResponseJson.ip, selectedNonMappedFarmField, base64ScreenCapture, mapCenterLatitude, mapCenterLongitude, digiFields);
  } 
  catch (error) {
    dispatch({
      type: 'SUBMIT_NON_MAPPED_FARM_FIELDS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'SUBMITTED_NON_MAPPED_FARM_FIELDS_SUCCESSFULLY',
    selectedNonMappedFarmField: selectedNonMappedFarmField,
  });
});

export const setGoogleMappingSessionCleared = () => (async (dispatch, getState) => {
  dispatch({
    type: 'SET_GOOGLE_MAPPING_SESSION_CLEARED',
  });
});

export const userDrewShape = (shape) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_DREW_SHAPE',
    shape: shape,
  });
});

export const userTappedResetDrawing = () => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_TAPPED_RESET_DRAWING',
  });
});

export const submitNonMappedFarmFieldsWithUserDrawings = (mapCenterLatitude, mapCenterLongitude, base64ScreenCapture) => (async (dispatch, getState) => {
  dispatch({
    type: 'SUBMIT_NON_MAPPED_FARM_FIELDS_WITH_USER_DRAWING_STARTED',
  });
  const {
    selectedNonMappedFarmField, 
    userDrawnShapes,
  } = getState().mapping;
  const agvanceUser = getState().auth.authorization.agvanceUser;
  const ipifyResponse = await fetch('https://api64.ipify.org?format=json');
  const ipifyResponseJson = await ipifyResponse.json();
  try {
      await emailCustomerFarmFieldMappingWithUserDrawing(agvanceUser, ipifyResponseJson.ip, selectedNonMappedFarmField, base64ScreenCapture, userDrawnShapes, mapCenterLatitude, mapCenterLongitude);
  } 
  catch (error) {
    dispatch({
      type: 'SUBMIT_NON_MAPPED_FARM_FIELDS_WITH_USER_DRAWING_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'SUBMITTED_NON_MAPPED_FARM_FIELDS_WITH_USER_DRAWING_SUCCESSFULLY',
    selectedNonMappedFarmField: selectedNonMappedFarmField,
  });
});

export const hideMapMyFieldsSuccessModal = () => ((dispatch, getState) => {
  dispatch({
    type: 'HIDE_MAP_MY_FIELDS_SUCCESS_MODAL',
  });
});

export const initNetOfFreightInterface = () => (async (dispatch, getState) => {
  dispatch({
    type: 'INIT_NET_OF_FREIGHT_INTERFACE',
  });
  await dispatch(fetchMappedFarmFieldsList());
});

export const fetchMappedFarmFieldsList = () => (async (dispatch, getState) => {
  dispatch({
    type: 'FETCH_MAPPED_FARM_FIELDS_LIST_STARTED',
  });
  const growerId = getState().auth.authorization.growerId;
  var response = null;
  try {
    response = await getCustomerFarmFieldsList(growerId);
  } 
  catch (error) {
    dispatch({
      type: 'FETCHING_MAPPED_FARM_FIELDS_LIST_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_MAPPED_FARM_FIELDS_LIST',
    mappedFarmFieldsList: response.body,
  });
});

export const userSelectedNetOfFreightCommodity = (selectedCommodity) => (async (dispatch, getState) => {
  await dispatch({
    type: 'USER_SELECTED_NET_OF_FREIGHT_COMMODITY',
    selectedCommodity: selectedCommodity,
  });
  const selectedNetOfFreightFarmField = getState().mapping.selectedNetOfFreightFarmField;
  if (selectedNetOfFreightFarmField !== null) {
    dispatch(userSelectedNetOfFreightFarmField(selectedNetOfFreightFarmField));
  }
});

export const userEnteredPerMileCost = (perMileCost) => (async (dispatch, getState) => {
  await dispatch({
    type: 'USER_ENTERED_PER_MILE_COST',
    perMileCost: perMileCost,
  });
});

export const userEnteredTruckBaseRate = (truckBaseRate) => (async (dispatch, getState) => {
  await dispatch({
    type: 'USER_ENTERED_TRUCK_BASE_RATE',
    truckBaseRate: truckBaseRate,
  });
});

export const userSelectedNetOfFreightFarmField = (selectedNetOfFreightFarmField) => (async (dispatch, getState) => {
  if (getState().mapping.selectedNetOfFreightFarmField !== selectedNetOfFreightFarmField) {
    await dispatch({
      type: 'CLEAR_MAPPED_FARM_FIELD_POLYGONS',
    });
  }
  dispatch({
    type: 'USER_SELECTED_NET_OF_FREIGHT_FARM_FIELD',
    selectedNetOfFreightFarmField: selectedNetOfFreightFarmField,
  });
  dispatch({
    type: 'FETCH_NET_OF_FREIGHT_LOCATIONS_STARTED',
  });
  var response = null;
  try {
    response = await getNetOfFreightLocations(selectedNetOfFreightFarmField.Longitude, selectedNetOfFreightFarmField.Latitude, getState().mapping.netOfFreightSelectedCommodity);
  } 
  catch (error) {
    dispatch({
      type: 'FETCHING_NET_OF_FREIGHT_LOCATIONS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_NET_OF_FREIGHT_LOCATIONS',
    locations: response.body,
  });
});

export const setUserDraggedOrigin = (position) => (async (dispatch, getState) => {
  await dispatch({
    type: 'SET_USER_DRAGGED_ORIGIN',
    position: position,
  });
  dispatch({
    type: 'FETCH_NET_OF_FREIGHT_LOCATIONS_STARTED',
  });
  var response = null;
  try {
    const selectedNetOfFreightFarmField = getState().mapping.selectedNetOfFreightFarmField;
    const netOfFreightSelectedCommodity = getState().mapping.netOfFreightSelectedCommodity;
    response = await getNetOfFreightLocations(selectedNetOfFreightFarmField.Longitude, selectedNetOfFreightFarmField.Latitude, netOfFreightSelectedCommodity);
  } 
  catch (error) {
    dispatch({
      type: 'FETCHING_NET_OF_FREIGHT_LOCATIONS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_NET_OF_FREIGHT_LOCATIONS',
    locations: response.body,
  });
});

export const fetchFarmFieldsWithNutrientRemoval = () => (async (dispatch, getState) => {
  dispatch({
    type: 'FETCH_FARM_FIELDS_WITH_NUTRIENT_REMOVAL_STARTED',
  });
  const growerId = getState().auth.authorization.growerId;
  var response = null;
  try {
    response = await getCustomerFarmFieldsWithNutrientRemoval(growerId);
  } 
  catch (error) {
    dispatch({
      type: 'FETCHING_FARM_FIELDS_WITH_NUTRIENT_REMOVAL_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_FARM_FIELDS_WITH_NUTRIENT_REMOVAL',
    farmFieldsWithNutrientRemoval: response.body,
  });
});

export const userSelectedFarmFieldWithNutrientRemoval = (selectedFarmFieldWithNutrientRemoval) => (async (dispatch, getState) => {
  await dispatch({
    type: 'USER_SELECTED_FARM_FIELD_WITH_NUTRIENT_REMOVAL',
    selectedFarmFieldWithNutrientRemoval: selectedFarmFieldWithNutrientRemoval,
  });
});